module.exports = __webpack_public_path__ + "static/media/logo-black.51542596.svg";